/**
 * Data loaders — wired into `config.loaders`. NSW RLGSP has no summary tables,
 * so the shared shell treats the missing `summary` loader as empty success.
 */

import { loadSystemLayers } from '#lib/common/loaders.js';
import { NSW_RLGSP_DATASET, buildSystemLayers } from './layers';

export const loadSystem = (apiKey: string) =>
	loadSystemLayers(apiKey, [NSW_RLGSP_DATASET], buildSystemLayers);
